import type { VisitExportItem } from "@services/visits/export/type";

export { type VisitExportItem };
export const VISITS_EXPORT_HEADS = [
  { id: "id", label: "ID" },
  { id: "date", label: "Data" },
  { id: "responsibleTeam", label: "Equipe Responsável" },
  { id: "visitType", label: "Tipo de Visita" },
  { id: "sampleTypes", label: "Tipos de Amostra" },
  { id: "locationId", label: "ID do Local" },
  { id: "attachmentsCount", label: "Anexos" },
  { id: "registeredBy", label: "Registrado por" },
  { id: "createdAt", label: "Criado em" },
  { id: "updatedAt", label: "Atualizado em" },
];
